import 'core-js/es6/map';
import 'core-js/es6/set';
import 'raf/polyfill';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom';
import { toast } from 'react-toastify';

import Authentication from '../requireAuth';
import ZalandoAuth from '../zalandoAuth';
// import { ROOT_URL } from '../../actions'
import { Header, Footer } from '../index';
import {
  Login,
  CreateBrands,
  BrandSummary,
  SuppDataCategory,
  SuppDataStyles,
  SuppDataRetailers,
  SuppDataPrice,
  SuppDataGender,
  BrandLanding,
  BrandSentences,
  SuppDataTypes,
  SuppDataAlias,
  SuppDataSocialMedia,
  SuppDataImage,
  Rating,
  SearchBrand,
  BrandGeneral,
  BrandContact,
  BrandCauses,
  SuppDataSku,
  ZalandoSearch,
  ZalandoBrandPage,
} from '../../pages';
import ScrollToTop from '../scrollToTop';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';

export class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      currentBrand: {
        'name': '',
        'url': '',
      },
    };
    toast.configure();
  }

  render() {
    return (
      <Router>
        <div>
          {/* <ErrorBoundary componentName="App"> */}
          <Header />
          <ScrollToTop>
            <div className={this.props.login ? 'container-body' : 'container-body-login'}>
              <Route exact path='/' component={Authentication(SearchBrand)} />
              <Route path='/login' component={Login} />
              <Route path='/dashboard' component={ZalandoAuth(ZalandoSearch)} />
              <Route path='/brandPage/:id' component={ZalandoAuth(ZalandoBrandPage)} />
              <Route path='/searchBrand' component={Authentication(SearchBrand)} />
              <Route path='/brandLanding/:id' component={Authentication(BrandLanding)} />
              <Route path='/brandSummary/:id' component={Authentication(BrandSummary)} />
              <Route path='/createBrand' component={Authentication(CreateBrands)} />
              <Route path='/brandGeneral/:id' component={Authentication(BrandGeneral)} />
              <Route path='/brandContact/:id' component={Authentication(BrandContact)} />
              <Route path='/env-resource/:id' component={Authentication(Rating)} />
              <Route path='/env-standards-compliance/:id' component={Authentication(Rating)} />
              <Route path='/env-climate-change/:id' component={Authentication(Rating)} />
              <Route path='/env-chemicals/:id' component={Authentication(Rating)} />
              <Route path='/env-water/:id' component={Authentication(Rating)} />
              <Route path='/env-positive-citizenship/:id' component={Authentication(Rating)} />
              <Route path='/env-negative-citizenship/:id' component={Authentication(Rating)} />
              <Route path='/labour-ethical-fashion-report/:id' component={Authentication(Rating)} />
              <Route path='/labour-certification/:id' component={Authentication(Rating)} />
              <Route path='/labour-policies-worker-empowerment/:id' component={Authentication(Rating)} />
              <Route path='/labour-supply-chain/:id' component={Authentication(Rating)} />
              <Route path='/labour-low-risk-production/:id' component={Authentication(Rating)} />
              <Route path='/labour-living-wage/:id' component={Authentication(Rating)} />
              <Route path='/labour-knowing-suppliers/:id' component={Authentication(Rating)} />
              <Route path='/labour-supplier-relationships-auditing/:id' component={Authentication(Rating)} />
              <Route path='/labour-positive-citizenship/:id' component={Authentication(Rating)} />
              <Route path='/labour-negative-citizenship/:id' component={Authentication(Rating)} />
              <Route path='/animal-animal-products/:id' component={Authentication(Rating)} />
              <Route path='/animal-positive-citizenship/:id' component={Authentication(Rating)} />
              <Route path='/animal-negative-citizenship/:id' component={Authentication(Rating)} />
              <Route path='/brandCauses/:id' component={Authentication(BrandCauses)} />
              <Route path='/brandSentences/:id' component={Authentication(BrandSentences)} />
              <Route path='/suppDataCategory/:id' component={Authentication(SuppDataCategory)} />
              <Route path='/suppDataStyles/:id' component={Authentication(SuppDataStyles)} />
              <Route path='/suppDataRetailers/:id' component={Authentication(SuppDataRetailers)} />
              <Route path='/suppDataPrice/:id' component={Authentication(SuppDataPrice)} />
              <Route path='/suppDataGender/:id' component={Authentication(SuppDataGender)} />
              <Route path='/suppDataTypes/:id' component={Authentication(SuppDataTypes)} />
              <Route path='/suppDataAlias/:id' component={Authentication(SuppDataAlias)} />
              <Route path='/suppDataSocialMedia/:id' component={Authentication(SuppDataSocialMedia)} />
              <Route path='/suppDataImage/:id' component={Authentication(SuppDataImage)} />
              <Route path='/suppDataSku/:id' component={Authentication(SuppDataSku)} />
            </div>
          </ScrollToTop>
          <Footer />
          {/* </ErrorBoundary> */}
        </div>
      </Router>
    );
  }
}

function mapStateToProps(state) {
  return {login: state.login};
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App/App.js